import React, { lazy } from 'react';
import { CalendarIcon, FileTextIcon, CheckCircleIcon } from 'lucide-react';
import { Reveal } from './Reveal';
const IMG = 'https://cdn.magicpatterns.com/uploads/kh8kGEHNiFrx5XwSLvkrqs/mujer_con_celular.webp';
const features = [{
  icon: CalendarIcon,
  title: 'Un 1% cada día, durante 30 días',
  desc: 'Pequeños ajustes diarios que se sienten posibles y se acumulan en un cambio real.'
}, {
  icon: FileTextIcon,
  title: 'Acciones simples para tu rutina',
  desc: 'Pasos claros que puedes aplicar sin darle la vuelta a tu día ni invertir horas.'
}, {
  icon: CheckCircleIcon,
  title: 'Tu progreso, sin presión',
  desc: 'Marca lo que haces y celebra cada avance, a tu ritmo y con calma.'
}];
export function WhatIsSection() {
  return <section className="w-full bg-white py-20 sm:py-28" data-id="element-217" data-mp="35b50kpacew1a">
      <div className="mx-auto max-w-6xl px-4 sm:px-6" data-id="element-218" data-mp="35amyvd4wvplz">
        <Reveal className="mx-auto max-w-2xl text-center" data-id="element-219" data-mp="3a96l7enf33ev">
          <h2 className="font-serif text-3xl font-semibold text-tinta sm:text-4xl lg:text-5xl" data-id="element-220" data-mp="3absqt8qqz8ug">
            Tu coach hormonal en la palma de tu mano
          </h2>
          <p className="mt-4 text-lg leading-relaxed text-tinta/70" data-id="element-221" data-mp="gfgm4ru4ffwu">
            El Método del 1% convierte el cambio en algo posible: una acción
            sencilla cada día, sin complicarte ni dedicar horas extra. Solo
            pequeños pasos que, con el tiempo, te devuelven a ti.
          </p>
        </Reveal>

        <div className="mt-12 grid items-center gap-12 lg:grid-cols-2 lg:gap-16" data-id="element-222" data-mp="1i638xf5f7r3">
          <Reveal data-id="element-223" data-mp="3stzegutue0vf">
            <div className="overflow-hidden rounded-3xl shadow-xl shadow-tinta/10" data-id="element-224" data-mp="3stfu77gpz0e8">
              <img src={IMG} alt="Mujer sonriente usando la app Cambio Hormonal desde una cama acogedora con luz cálida" className="h-full max-h-[560px] w-full object-cover" loading="lazy" data-id="element-225" data-mp="3ougwo7xbi5wt" />
            </div>
          </Reveal>

          <div className="grid gap-5" data-id="element-226" data-mp="39xgasl1t5569">
            {features.map((f, i) => <Reveal key={f.title} delay={i * 0.1} data-id="element-227" data-mp="308at1t3gpmwk" data-mpi={i}>
                <div className="flex gap-5 rounded-2xl border border-nude/60 bg-crema/50 p-5 sm:p-6" data-id="element-228" data-mp="357vr81at5r88">
                  <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-rosa/15 text-rosa-dark" data-id="element-229" data-mp="2r8nqh3yzyb1x">
                    <f.icon className="h-6 w-6" strokeWidth={1.6} data-id="element-230" data-mp="2vb0u9mu6nyw2" />
                  </span>
                  <div data-id="element-231" data-mp="3izabebggbygv">
                    <h3 className="font-serif text-xl font-semibold text-tinta" data-id="element-232" data-mp="3j03m1nij784a">
                      {f.title}
                    </h3>
                    <p className="mt-1 text-tinta/70" data-id="element-233" data-mp="3a78dajtuuu9r">{f.desc}</p>
                  </div>
                </div>
              </Reveal>)}
          </div>
        </div>

      </div>
    </section>;
}